import { AfterContentInit, ContentChildren, Directive, EventEmitter, OnDestroy, Output, QueryList } from '@angular/core';
import { NgModel } from '@angular/forms';
import { auditTime, EMPTY, merge, startWith, Subject, switchMap, takeUntil } from 'rxjs';

@Directive({
    selector: '[formSectionWatcher]',
})
export class FormSectionWatcherDirective implements AfterContentInit, OnDestroy {
    @ContentChildren(NgModel, { descendants: true })
    models: QueryList<NgModel>;

    @Output()
    formSectionChanged: EventEmitter<void> = new EventEmitter<void>();

    private destroy$: Subject<void> = new Subject<void>();

    ngAfterContentInit(): void {
        // Handles dynamic controls (ngIf / ngFor / async rendering)
        this.models.changes
            .pipe(
                startWith(this.models),
                switchMap(() => {
                    const valueChanges = this.models.map((model: NgModel) => model.valueChanges).filter((x): x is NonNullable<typeof x> => !!x);

                    return valueChanges.length ? merge(...valueChanges) : EMPTY;
                }),
                auditTime(0),
                takeUntil(this.destroy$),
            )
            .subscribe((): void => {
                this.formSectionChanged.emit();
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
